import validateType from "./validateType";
import validateFirstName from "./validateFirstName";
import validateLastName from "./validateLastName";
import validateExternalId from "./validateExternalId";
import validateJerseyNumber from "./validateJerseyNumber";
import validateStatusAffiliated from "./validateStatusAffiliated";
import validateDesignation from "./validateDesignation";
import validateBirthDate from "./validateBirthDate";
import validateShotHand from "./validateShotHand";
import validateCountry from "./validateCountry";

export default [
  validateType,
  validateFirstName,
  validateLastName,
  validateExternalId,
  validateJerseyNumber,
  validateStatusAffiliated,
  // validatePosition, // this is added later so we can support dynamic positions
  validateDesignation,
  validateBirthDate,
  validateShotHand,
  validateCountry
];
